"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EvidenceVoterKind = exports.EvidenceProvenanceSchema = exports.EvidenceExtractorVoterSchema = void 0;
exports.voterKeyFor = voterKeyFor;
exports.voterKindOf = voterKindOf;
const z = require("zod");
const agentic_extractor_registry_1 = require("../AgenticExtraction/agentic-extractor-registry");
const edit_provenance_types_1 = require("../Auth/edit-provenance.types");
const evidence_errors_1 = require("./evidence.errors");
const evidence_voter_tier_1 = require("./evidence-voter-tier");
exports.EvidenceExtractorVoterSchema = z.object({
    name: z.nativeEnum(agentic_extractor_registry_1.AgenticExtractorName),
    packageId: z.string().min(1),
});
exports.EvidenceProvenanceSchema = edit_provenance_types_1.EditProvenanceSchema.extend({
    workflowId: z.string().nullable(),
    stepName: z.string().nullable(),
    extractor: exports.EvidenceExtractorVoterSchema.nullable(),
    voterTier: evidence_voter_tier_1.EvidenceVoterTierSchema,
});
var EvidenceVoterKind;
(function (EvidenceVoterKind) {
    EvidenceVoterKind["User"] = "user";
    EvidenceVoterKind["Extractor"] = "extractor";
})(EvidenceVoterKind || (exports.EvidenceVoterKind = EvidenceVoterKind = {}));
function voterKeyFor(provenance) {
    if (provenance.extractor !== null) {
        if (provenance.extractor.packageId === '') {
            throw new evidence_errors_1.EvidenceVoterIdentityError(provenance.agency, 'packageId');
        }
        return `${EvidenceVoterKind.Extractor}:${provenance.extractor.name}:${provenance.extractor.packageId}`;
    }
    if (provenance.actorUserId === null || provenance.actorUserId === '') {
        throw new evidence_errors_1.EvidenceVoterIdentityError(provenance.agency, 'actorUserId');
    }
    return `${EvidenceVoterKind.User}:${provenance.actorUserId}`;
}
function voterKindOf(voterKey) {
    const kind = Object.values(EvidenceVoterKind).find((candidate) => voterKey.startsWith(`${candidate}:`));
    if (kind === undefined) {
        throw new evidence_errors_1.EvidenceVoterKeyError(voterKey);
    }
    return kind;
}
//# sourceMappingURL=evidence-provenance.js.map